import { create } from 'zustand'
import { formularioTopSlice } from './slices/formularioTopSlice'

const useTopStore = create((set,get) => ({
    isLoading: true,
    platillos: [],
    multiImagenes: [],
    multiImagenesTemp: [], 
    sucursales :[],
    sucursalSelecionada:[],
    esMostrar: true,
    handleSucursales: (e) => {
      set({ sucursalSelecionada: [e] })
      set({ multiImagenesTemp: get().multiImagenes })
      set({ esMostrar: false })
      setTimeout(() => {
        set({ esMostrar: true })
      }, 50);
    },
    handleChangeImagen: (e) => set({ multiImagenesTemp: e }),
    ...formularioTopSlice(set,get),
    iniciar: async() => {
        await get().obtenerTop();
    },
    limpiar: () => {
      set({
        isLoading: true,
        platillos: [],
        multiImagenes: []
      })
    }
}))
  
export default useTopStore